import styled from 'styled-components';
import { PlayLinkContainer } from '../../components/Link';
import { regularWhite, defaultTextMargin, fontWeightBold } from '../design-tokens';
import { playFontSize } from '../typography/helpers';

export const PlayTagWrapper = styled(PlayLinkContainer)`
    color: ${regularWhite};
    margin: ${defaultTextMargin};
    font-weight: ${fontWeightBold};
    ${playFontSize(1.3)}
`;
